import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import ConfigPage from "../pages/config/page";
import AnalysisPage from "../pages/analysis/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <ConfigPage />,
  },
  {
    path: "/config",
    element: <ConfigPage />,
  },
  {
    path: "/analysis",
    element: <AnalysisPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
